import { render, staticRenderFns } from "./sig.vue?vue&type=template&id=858cd5a6&scoped=true&"
import script from "./sig.vue?vue&type=script&lang=js&"
export * from "./sig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858cd5a6",
  null
  
)

export default component.exports